import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import type { MeetingCallMode } from '../../../../../store/meeting/meeting.models';

export type OutgoingCallModalResult = 'join' | 'close' | 'cancel';
export type OutgoingCallModalState = 'pending' | 'ready' | 'declined';

export type OutgoingCallModalData = {
  contactName: string;
  avatarUrl: string | null;
  initials: string;
  mode: MeetingCallMode;
};

@Component({
  selector: 'app-outgoing-call-modal',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './outgoing-call-modal.component.html',
  styleUrl: './outgoing-call-modal.component.scss',
})
export class OutgoingCallModalComponent {
  private readonly dialogRef = inject(MatDialogRef<OutgoingCallModalComponent, OutgoingCallModalResult>);
  private readonly cdr = inject(ChangeDetectorRef);
  protected readonly data = inject<OutgoingCallModalData>(MAT_DIALOG_DATA);

  protected state: OutgoingCallModalState = 'pending';

  setState(state: OutgoingCallModalState): void {
    this.state = state;
    this.cdr.detectChanges();
  }

  protected close(): void {
    this.dialogRef.close('close');
  }

  protected cancel(): void {
    this.dialogRef.close('cancel');
  }

  protected join(): void {
    this.dialogRef.close('join');
  }

  protected getEyebrow(): string {
    if (this.state === 'declined') {
      return 'Call Declined';
    }
    if (this.state === 'ready') {
      this.dialogRef.close('join');
      return 'Call Connected';
      
    }
    return this.data.mode === 'audio' ? 'Calling' : 'Starting Video Call';
  }

  protected getTitle(): string {
    if (this.state === 'declined') {
      return `${this.data.contactName} declined the call`;
    }
    if (this.state === 'ready') {
      return `${this.data.contactName} answered`;
    }
    return `Calling ${this.data.contactName}...`;
  }

  protected getSubtitle(): string {
    if (this.state === 'declined') {
      return 'You can close this window and try again anytime.';
    }
    if (this.state === 'ready') {
      return 'Join the call when you are ready.';
    }
    return `Waiting for ${this.data.contactName} to answer.`;
  }
}
